import { Injectable } from '@angular/core';
import { Observable, filter } from 'rxjs';
import { ApiDashboardService } from './api_dashboard.service';

interface Miembro {
  login: string;
  celular: string;
  correo_facturacion: string;
  direccion_facturacion: string;
  fecha_nacimiento: string;
  genero: string;
  identificacion: string;
  nombre: string;
  tipo_documento: string;
}

interface CreateMiembro {
  miembros: Miembro[];
}

@Injectable({
  providedIn: 'root',
})
export class InitComponentApi {
  constructor(private apiService: ApiDashboardService) {}

  // Obtener lista de usuarios con parámetros opcionales
  async getUsers(auth_id: string, email: string): Promise<any> {
    try {
      let empresa = JSON.parse(localStorage.getItem('empresa'))?.id;
      let params: any = { user_id: auth_id, email: email };

      if (empresa) {
        params['empresa_id'] = empresa;
      }

      // Llamada a la API con los parámetros adecuados
      let response = await this.apiService.getData('init_components/variables', { 'Content-Type': 'application/json' }, params).toPromise();

      // Almacena perfil en localStorage
      localStorage.setItem('perfil_usuario', JSON.stringify(response[0]));
      console.log('respose init:', response);
      console.log('esta es la empresa: ', empresa);

      // Si hay empresa en localStorage, se actualiza
      if (empresa) {
        let empresaSeleccionada = response[0].empresas.find((e: any) => e.id == empresa);
        if (empresaSeleccionada) {
          localStorage.setItem('empresa', JSON.stringify(empresaSeleccionada));
        }
      }

      return response;
    } catch (error) {
      console.error('Error obteniendo usuarios:', error);
      throw error;
    }
  }

  async createJhiUser(auth_id: string, email: string): Promise<any> {
    try {
      const response = await this.apiService
        .postData('init_components/create_user', { user_id: auth_id, email: email }, { 'Content-Type': 'application/json' })
        .toPromise();
      return response;
    } catch (error) {
      console.error('Error obteniendo usuarios:', error);
      throw error;
    }
  }

  async createMiembro(payload: CreateMiembro): Promise<any> {
    try {
      // Directly send the payload as expected by the backend
      const response = await this.apiService
        .postData('init_components/create_miembro', payload, { 'Content-Type': 'application/json' })
        .toPromise();
      return response;
    } catch (error) {
      console.error('Error creando miembro:', error);
      throw error;
    }
  }
}
